<template>
    <Row type="none" >
        <div class="bg-white rounded shadow min-h-screen">
            
            <Modal
                :text="modalText"
                id="modal_show"
            />
            
            <Modal
                :text="modalText"
                id="modal_router"
                :on-ok-pressed="goNext"
                :is-ok-only="false"
                ok-text="yes"
                cancel-text="no"
            />
            
            <ModalWithPicture id="show_picture" :img="itemImageUrl" :title="itemName"/>
            
            <div class="bg-white rounded shadow px-3 pb-5">
                
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    
                    <div class="col-span-1 position-relative pl-0 mt-5">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('product.chooseAndAdd') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <v-select
                            :options="getPurchasePageProducts"
                            label="name"
                            :reduce="options => options"
                            :taggable="isTaggable"
                            :noDrop="isNoDrop"
                            :closeOnSelect="hasCloseOnSelect"
                            :filterable="isNeedFilter"
                            @option:selecting="clearAddUOM"
                            @search:focus="clearInput"
                            @search:blur="selectProduct"
                            v-model="modelForm.product"
                            @input="whenSelectProduct"
                        >
                            <template #no-options="{}">
                                {{ $t("selectError") }}
                            </template>
                            <template #search="{ attributes, events }">
                                <input
                                    v-model="search.barCode"
                                    class="vs__search"
                                    v-bind="attributes"
                                    v-on="events"
                                    @input="(value) => {searchProductByBarCode(value)}"
                                    ref="search"
                                />
                            </template>
                        </v-select>
                    </div>
                    
                    <div class="col-span-1 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-4">
                            {{ $t('category') }}
                        </div>
                        <TreeCheckBoxForAddMany
                            class="px-0"
                            model-name="categories"
                            :model-form="modelForm"
                            :options="getProductCategoriesTree"
                            :errors="errors"
                            :set-category="setCategory"
                            :is-disabled="modelForm.product === null"
                            value="value"
                        />
                    
                    </div>
                
                </div>
                
                <div :class="isExistProduct ? 'grid grid-cols-1 md:grid-cols-9 gap-3' : 'grid grid-cols-1 md:grid-cols-10 gap-3'">
                    
                    <div class="col-span-3 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('productPurchase.price') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <b-form-input
                            min="0"
                            class="border-gray-400 disabled-input h-11"
                            :disabled="modelForm.product === null"
                            @input="setPurchasePrice"
                            v-model="modelForm.purchasePrice"
                            type="number"
                        />
                    </div>
                    
                    <div class="col-span-3 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('currencyRate.choose') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <b-form-select
                            class="h-11 border-gray-300"
                            @change="selectPurchaseCurrency"
                            v-model="modelForm.purchaseCurrency">
                            <b-form-select-option value="UZS">UZS</b-form-select-option>
                            <b-form-select-option value="USD">USD</b-form-select-option>
                            <b-form-select-option value="RUB">RUB</b-form-select-option>
                        </b-form-select>
                    </div>
                    
                    <div class="col-span-3 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('unitOfMeasure.unitOfMeasure') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <div v-if="modelForm.additionalUnitOfMeasures.length > 0">
                            <b-form-select
                                class="h-11 border-gray-300 bg-white focus:ring-0"
                                @change="setPurchaseAddUOM"
                                v-model="modelForm.purchasePriceUOM"
                            >
                                <b-form-select-option
                                    v-for="(item, index) in modelForm.additionalUnitOfMeasures"
                                    :key="index"
                                    :value="item">
                                    {{ item.unitOfMeasure }}
                                </b-form-select-option>
                            </b-form-select>
                        </div>
                        <div v-else-if="hasAdditionalUnitOfMeasure">
                            <v-select
                                :options="unitOfMeasures"
                                label="name"
                                :reduce="options => options.name"
                                v-model="modelForm.moreUnitOfMeasure[modelForm.moreUnitOfMeasure.length - 1].unitOfMeasure"
                                :disabled="true"
                            >
                                <template #no-options="{}">
                                    {{ $t("selectError") }}
                                </template>
                            </v-select>
                        </div>
                        <div v-else>
                            <v-select
                                :options="unitOfMeasures"
                                label="name"
                                @input="setUOM"
                                :taggable="true"
                                :reduce="options => options.name"
                                v-model="modelForm.unitOfMeasure"
                                :disabled="isDisabled || modelForm.product === null"
                            >
                                <template #no-options="{}">
                                    {{ $t("selectError") }}
                                </template>
                            </v-select>
                        </div>
                    </div>
                    
                    <div v-if="!isExistProduct" class="col-span-1 position-relative pl-0 mt-10">
                        <img v-if="!hasAdditionalUnitOfMeasure" @click="showAdditionalUOM" src="/images/more.png" alt="" class="h-11 cursor-pointer">
                        <img v-if="hasAdditionalUnitOfMeasure" @click="closeAdditionalUOM" src="/images/minus.png" alt="" class="h-11 cursor-pointer">
                    </div>
                </div>
            </div>
            
            <div v-if="hasAdditionalUnitOfMeasure" class="bg-white rounded shadow px-3 pb-5 mt-3">
                
                <div v-for="(unit, index) in modelForm.moreUnitOfMeasure" :key="index" class="grid grid-cols-1 md:grid-cols-10 gap-3">
                    <div class="col-span-3 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('unitOfMeasure.unitOfMeasure') }}
                        </div>
                        <b-form-input class="h-11 border-gray-300 focus:ring-0" list="my-datalist" v-model="unit.unitOfMeasure"></b-form-input>
                        <datalist id="my-datalist">
                            <option
                                v-for="(itemUnit, indexItem) in unitOfMeasures" :key="indexItem"
                            >
                                {{ itemUnit.name }}
                            </option>
                        </datalist>
                    </div>
                    
                    <div class="col-span-1 position-relative flex justify-content-center mt-10">
                        <img src="/images/equal-to.png" alt="" class="h-11 position-absolute bottom-1">
                    </div>
                    
                    <div class="col-span-3 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('unitOfMeasure.comparison') }}
                        </div>
                        <input
                            class="form-control h-11 border-gray-300 focus:ring-0 d-inline"
                            type="number"
                            min="0"
                            v-model="unit.howMany"
                        />
                    </div>
                    
                    <div class="col-span-2 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                        
                        </div>
                        <v-select
                            :options="unitOfMeasures"
                            label="name"
                            :taggable="true"
                            :reduce="options => options.name"
                            v-model="modelForm.unitOfMeasure"
                            :disabled="isDisabled || modelForm.product === null"
                        >
                            <template #no-options="{}">
                                {{ $t("selectError") }}
                            </template>
                        </v-select>
                    </div>
                    
                    <div class="col-span-1 position-relative pl-0 mt-10">
                        <img v-if="!index" @click="addMoreUnit(index)" src="/images/more.png" alt="" class="h-11">
                        <img v-if="index" @click="deleteOneUnit(index)" src="/images/minus.png" alt="" class="h-11">
                    </div>
                </div>
            
            </div>
            
            <div class="bg-white rounded shadow px-3 mt-3">
                
                <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
                    <div class="col-span-2 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('warehouse.choose') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <v-select
                            :options="getWarehouses"
                            label="name"
                            :reduce="options => options"
                            v-model="modelForm.warehouse"
                            @option:selected="setWarehouse"
                            :disabled="modelForm.product === null"
                        >
                            <template #no-options="{}">
                                {{ $t("selectError") }}
                            </template>
                        </v-select>
                    </div>
                    
                    <div class="col-span-1 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('productPriceModify.marja') }}
                        </div>
                        <b-form-input
                            class="h-11 border-gray-300"
                            v-model.number="modelForm.marja"
                            min="0"
                            :disabled="hasAdditionalUnitOfMeasure"
                            @input="setMarja"
                            type="number"
                        />
                    </div>
                    
                    <div class="col-span-1 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('product.barcode') }}
                        </div>
                        <b-form-input
                            class="h-11 border-gray-300 disabled-input"
                            :min="0"
                            :disabled="modelForm.product === null"
                            @input="setBarcode"
                            v-model="modelForm.barcode"
                            type="number"
                        />
                    </div>
                </div>
                
                <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div class="col-span-1 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('sellingPrice') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <b-form-input
                            class="h-11 border-gray-300 disabled-input"
                            v-model="modelForm.sellingPrice"
                            :disabled="modelForm.product === null"
                            min="0"
                            @input="setSellingPrice"
                            type="number"
                        />
                    </div>
                    
                    <div class="col-span-1 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('currencyRate.choose') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            @change="selectSellingCurrency(false)"
                            v-model="modelForm.sellingCurrency">
                            <b-form-select-option value="UZS">UZS</b-form-select-option>
                            <b-form-select-option value="USD">USD</b-form-select-option>
                            <b-form-select-option value="RUB">RUB</b-form-select-option>
                        </b-form-select>
                    </div>
                    
                    <div class="col-span-1 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('unitOfMeasure.unitOfMeasure') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <div v-if="modelForm.additionalUnitOfMeasures.length > 0">
                            <b-form-select
                                @change="setSellingAddUOM"
                                v-model="modelForm.salePriceUOM"
                            >
                                <b-form-select-option
                                    v-for="(item, index) in modelForm.additionalUnitOfMeasures"
                                    :key="index"
                                    :value="item">
                                    {{ item.unitOfMeasure }}
                                </b-form-select-option>
                            </b-form-select>
                        </div>
                        <div v-else>
                            <v-select
                                :options="unitOfMeasures"
                                label="name"
                                @input="setUOM"
                                :taggable="true"
                                :reduce="options => options.name"
                                v-model="modelForm.unitOfMeasure"
                                :disabled="isDisabled || modelForm.product === null"
                            >
                                <template #no-options="{}">
                                    {{ $t("selectError") }}
                                </template>
                            </v-select>
                        </div>
                    </div>
                </div>
                
                <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div class="col-span-1 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('productPurchase.alertAmount') }}
                        </div>
                        <b-form-input
                            class="h-11 border-gray-300 disabled-input"
                            v-model="modelForm.alertAmount"
                            min="0"
                            :disabled="modelForm.product === null"
                            @input="setAlertAmount"
                            type="number"
                        />
                    </div>
                    
                    <div class="col-span-1 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('unitOfMeasure.short') }}
                        </div>
                        <div v-if="modelForm.additionalUnitOfMeasures.length > 0">
                            <b-form-input
                                list="my-list-id"
                                v-model="modelForm.alertAmountUOM"
                                class="pl-1 pr-0"
                            ></b-form-input>
                            <datalist id="my-list-id">
                                <option v-for="(item, index) in unitOfMeasures" :key="index" class="px-0">
                                    {{ item.name }}
                                </option>
                            </datalist>
                        </div>
                        <div v-else>
                            <v-select
                                :options="unitOfMeasures"
                                label="name"
                                @input="setUOM"
                                :taggable="true"
                                :reduce="options => options.name"
                                v-model="modelForm.unitOfMeasure"
                                :disabled="modelForm.additionalUnitOfMeasures.length > 0 ? false : isDisabled || modelForm.product === null"
                            >
                                <template #no-options="{}">
                                    {{ $t("selectError") }}
                                </template>
                            </v-select>
                        </div>
                    </div>
                    
                    <div class="col-span-1 position-relative pl-0 mt-10">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('product.expirationDate') }}
                        </div>
                        <InputBox
                            :inputFunction="setExpirationDate"
                            :model-form="modelForm"
                            model-name="shelfLife"
                            :no-margin-top="true"
                            :errors="errors"
                            type="date"
                            :is-disabled="modelForm.product === null"
                            class="px-0"
                        />
                    </div>
                </div>
                
                <div class="grid grid-cols-10">
                    <div class="col-span-2">
                        <b-form-checkbox v-model="modelForm.isWeigher" @input="setIsWeigher" class="pt-4" size="lg">
                            <span class="text-xs">{{ $t('scale.scaleProduct') }}</span>
                        </b-form-checkbox>
                    </div>
                    <div class="col-span-8">
                        <CurrencyCollapse :is-bg-white="true" class="mt-4 pb-2">
                            <div class="grid grid-cols-10 gap-3">
                                <div class="col-span-2 position-relative pl-0">
                                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                                        {{ $t('image.choiceImageFile') }}
                                    </div>
                                    
                                    <label for="image" class="rounded w-full h-28 flex justify-content-center align-items-center" style="border: 1px solid #e0e0e1">
                                        
                                        <img v-if="!isLoadingError" src="/images/imageIcon.png" alt="" class="h-11 cursor-pointer block">
                                        <span
                                            v-if="isLoadingError"
                                            class="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        >
                            </span>
                                        
                                        <div
                                            v-if="modelForm.image && !isLoadingError"
                                            class="position-absolute text-main bottom-3"
                                        >
                                            {{ file.name }}
                                        </div>
                                    </label>
                                    <input
                                        id="image"
                                        style="display: none"
                                        type="file"
                                        :disabled="modelForm.product === null"
                                        accept="image/*"
                                        @change="importImage($event)"
                                    >
                                </div>
                                <div class="col-span-8 position-relative pl-0">
                                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                                        {{ $t('additionalInformation') }}
                                    </div>
                                    <textarea
                                        v-model="modelForm.additionalInformation"
                                        @input="setAdditionalInfo"
                                        class="h-28 border-gray-300 rounded w-full"
                                    />
                                </div>
                            </div>
                        </CurrencyCollapse>
                    </div>
                
                </div>
            
            </div>
            
            <div class="bg-white rounded shadow mt-3" style="max-height: 500px; overflow-y: scroll">
                <div v-if="data.productCreatePurchaseMakerDtos.length > 0" class="d-none d-md-block">
                    <table class="w-full" >
                        <thead class="bg-lightGray h-11 text-center font-bold sticky top-0 z-20">
                        <tr>
                            <td class="pl-3">#</td>
                            <td class="">{{ $t('product.title') }}</td>
                            <td class="">{{ $t('amount') }}</td>
                            <td class="">{{ $t('productPurchase.price') }}</td>
                            <td class="">{{ $t('sale.sum') }}</td>
                            <td class="d-none d-xl-table-cell">{{ $t('sellingPrice') }}</td>
                            <td class="d-none d-xl-table-cell">{{ $t('sale.sum') }}</td>
                            <td class="">{{ $t('warehouse.title') }}</td>
                            <td class="">{{ $t('actions') }}</td>
                        </tr>
                        </thead>
                        <tbody v-for="(item, index) of data.productCreatePurchaseMakerDtos" :key="index">
                        <tr :class="activeIndex === index ? 'h-11 bg-lightGray' : 'h-11 bg-white text-center'">
                            <td class="">{{ index + 1 }}</td>
                            <td class="text-main" @click="selectRow(index)">
                                <b-form-input
                                    style="box-shadow: none"
                                    :class="activeIndex === index ? 'bg-lightGray border-0 focus:ring-0 focus-within:outline-none text-main font-bold' : 'text-center bg-white border-0 text-main font-bold'"
                                    @keyup.enter="onPressEnter($event)"
                                    v-model="item.name">
                                </b-form-input>
                            </td>
                            <td class="">
                                <!--  additional unit of measures  -->
                                <template class="row" v-if="item.additionalUnitOfMeasures.length">
                                    
                                    <div
                                        v-for="(unit, i) in item.additionalUnitOfMeasures"
                                        :key="i"
                                    >
                                        <div class="flex mt-2">
                                            <img src="/images/Minus.png" alt="" class="h-5 lg:h-7 cursor-pointer mr-2" @click="decreaseAmount(item, unit, i)">
                                            <input
                                                class="rounded-bl rounded-tl border-0 h-5 lg:h-7 w-12 lg:w-16 bg-mediumGray focus:outline-none text-center text-main font-bold"
                                                v-model="unit.amount"
                                                @input="calcProductAmount(item, unit)"
                                            >
                                            <span class="h-5 lg:h-7 w-12 lg:w-20 bg-mediumGray rounded-tr rounded-br text-main font-bold flex align-items-center justify-content-center">
                                        {{ showUnitOfMeasure(unit.unitOfMeasure) }}
                                    </span>
                                            <img src="/images/Plus.png" alt="" class="h-5 lg:h-7 cursor-pointer ml-2" @click="increaseAmount(item, unit, i)">
                                        </div>
                                    </div>
                                </template>
                                
                                <!--  unit of measure  -->
                                <div v-else class="flex">
                                    <img src="/images/Minus.png" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer mr-2" @click="decreaseAmount(item)">
                                    <input
                                        class="rounded-bl rounded-tl border-0 h-5 lg:h-7 w-12 lg:w-16 bg-mediumGray focus:outline-none text-center text-main font-bold"
                                        v-model.number="item.amount"
                                        @input="calcProductAmount(item)"
                                    >
                                    <span class="h-5 lg:h-7 bg-mediumGray w-12 lg:w-20 rounded-tr rounded-br text-main font-bold flex align-items-center justify-content-center">
                                 {{ showUnitOfMeasure(item.product.unitOfMeasure) }}
                            </span>
                                    <img src="/images/Plus.png" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer ml-2" @click="increaseAmount(item)">
                                </div>
                            </td>
                            <td v-if="item.moreUnitOfMeasure.length > 0 && item.moreUnitOfMeasure[item.moreUnitOfMeasure.length - 1].howMany !== ''"
                                class="cursor-pointer px-3" @click="selectRow(index)">
                                {{
                                    numberWithCommas(Math.round(parseInt(item.purchasePrice) / parseInt(item.moreUnitOfMeasure[item.moreUnitOfMeasure.length - 1].howMany)))
                                }}
                                {{ showCurrencySymbolById(item.purchasePriceCurrency.id) }}
                            </td>
                            <td v-else class="cursor-pointer px-3" @click="selectRow(index)">
                                {{
                                    item.purchasePrice ? numberWithCommas(item.purchasePriceUOM ? Math.round(parseInt(item.purchasePrice) / item.purchasePriceUOM.howMany) : parseFloat(item.purchasePrice)) : ''
                                }}
                                {{ showCurrencySymbolById(item.purchasePriceCurrency.id) }}
                            </td>
                            <td class="cursor-pointer" @click="selectRow(index)">
                        <span v-if="item.purchasePriceCurrency.shortName === 'UZS'">

                            {{
                                item.purchasePrice ? numberWithCommas(item.purchasePriceUOM ? Math.round(item.amount * (parseInt(item.purchasePrice) / item.purchasePriceUOM.howMany)) : Math.round(item.amount * (parseInt(item.purchasePrice)))) : ''
                            }}

                        </span>
                                <span v-else>
                            {{
                                        item.purchasePrice ? numberWithCommas(item.purchasePriceUOM ? (item.amount * (parseFloat(item.purchasePrice) / item.purchasePriceUOM.howMany)).toFixed(2) : (item.amount * parseFloat(item.purchasePrice)).toFixed(2)) : ''
                                    }}
                        </span>
                            </td>
                            <td class="px-3 cursor-pointer d-none d-xl-table-cell" @click="selectRow(index)">
                                {{
                                    item.sellingPrice ? numberWithCommas(item.salePriceUOM ? Math.round(parseInt(item.sellingPrice) / item.salePriceUOM.howMany) : item.sellingPrice) : ''
                                }}
                                {{ showCurrencySymbolById(item.sellingPriceCurrency.id) }}
                            </td>
                            <td class="cursor-pointer d-none d-xl-table-cell" @click="selectRow(index)">
                        <span v-if="item.sellingPriceCurrency.shortName === 'UZS'">
                            {{
                                item.sellingPrice ? numberWithCommas(item.salePriceUOM ? Math.round(item.amount * (parseInt(item.sellingPrice) / item.salePriceUOM.howMany)) : item.moreUnitOfMeasure.length ? Math.round(item.amount * parseInt(item.sellingPrice) * parseFloat(item.moreUnitOfMeasure[item.moreUnitOfMeasure.length - 1].howMany)) : Math.round(item.amount * parseInt(item.sellingPrice))) : ''
                            }}

                        </span>
                                <span v-else>
                            {{
                                        item.sellingPrice ? numberWithCommas(item.salePriceUOM ? (item.amount * (parseFloat(item.sellingPrice) / item.salePriceUOM.howMany)).toFixed(2) : (item.amount * parseFloat(item.sellingPrice)).toFixed(2)) : ''
                                    }}
                        </span>
                            </td>
                            <td class="cursor-pointer" @click="selectRow(index)">{{
                                    item.warehouse.name
                                }}
                            </td>
                            <td class="">
                                <div @click="deleteRowTable(index)" class="">
                                    <img src="/images/Union.png" alt="" class="h-7 cursor-pointer">
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="data.productCreatePurchaseMakerDtos.length > 0" class="d-block d-md-none">
                    <table class="w-full">
                        <tbody v-for="(item, index) of data.productCreatePurchaseMakerDtos" :key="index" :class="activeIndex === index ? 'h-11 bg-lightGray' : 'h-11 bg-white'">
                        <tr class="pl-3 h-11">
                            <td class="font-bold pl-3">#</td>
                            <td class="pl-3">{{ index + 1 }}</td>
                        </tr>
                        <tr class="cursor-pointer h-11" @click="selectRow(index)">
                            <td class="font-bold pl-3">{{ $t('product.title') }}</td>
                            <td class="font-size">
                                <b-form-input
                                    :class="activeIndex === index ? 'bg-lightGray border-0 focus:ring-0 focus-within:outline-none text-main font-bold' : 'bg-white border-0 text-main font-bold'"
                                    v-model="item.name">
                                </b-form-input>
                            </td>
                        </tr>
                        <tr class=" h-11">
                            <td class="font-bold pl-3">{{ $t('amount') }}</td>
                            <td class="font-size">
                                <!--  additional unit of measures  -->
                                <template class="row" v-if="item.additionalUnitOfMeasures.length">
                                    
                                    <div
                                        v-for="(unit, i) in item.additionalUnitOfMeasures"
                                        :key="i"
                                    >
                                        <div class="flex mt-2">
                                            <img src="/images/Minus.png" alt="" class="h-5 lg:h-7 cursor-pointer mr-2" @click="decreaseAmount(item, unit, i)">
                                            <input
                                                class="rounded-bl rounded-tl border-0 h-5 lg:h-7 w-12 lg:w-16 bg-mediumGray focus:outline-none text-center text-main font-bold"
                                                v-model="unit.amount"
                                                @input="calcProductAmount(item, unit)"
                                            >
                                            <span class="h-5 lg:h-7 w-12 lg:w-20 bg-mediumGray rounded-tr rounded-br text-main font-bold flex align-items-center justify-content-center">
                                        {{ showUnitOfMeasure(unit.unitOfMeasure) }}
                                    </span>
                                            <img src="/images/Plus.png" alt="" class="h-5 lg:h-7 cursor-pointer ml-2" @click="increaseAmount(item, unit, i)">
                                        </div>
                                    </div>
                                </template>
                                
                                <!--  unit of measure  -->
                                <div v-else class="flex">
                                    <img src="/images/Minus.png" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer mr-2" @click="decreaseAmount(item)">
                                    <input
                                        class="rounded-bl rounded-tl border-0 h-5 lg:h-7 w-12 lg:w-16 bg-mediumGray focus:outline-none text-center text-main font-bold"
                                        v-model.number="item.amount"
                                        @input="calcProductAmount(item)"
                                    >
                                    <span class="h-5 lg:h-7 bg-mediumGray w-12 lg:w-20 rounded-tr rounded-br text-main font-bold flex align-items-center justify-content-center">
                                 {{ showUnitOfMeasure(item.product.unitOfMeasure) }}
                            </span>
                                    <img src="/images/Plus.png" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer ml-2" @click="increaseAmount(item)">
                                </div>
                            </td>
                        </tr>
                        <tr class="cursor-pointer h-11" @click="selectRow(index)">
                            <td class="font-bold pl-3">{{ $t('productPurchase.price') }}</td>
                            <td>
                                {{ item.purchasePrice ? numberWithCommas(parseFloat(item.purchasePrice)) : '' }}
                                {{ showCurrencySymbolById(item.purchasePriceCurrency.id) }}
                            </td>
                        </tr>
                        <tr class="cursor-pointer pl-3 h-11" @click="selectRow(index)">
                            <td class="font-bold pl-3">{{ $t('sale.sum') }}</td>
                            <td>
                        <span v-if="item.purchasePriceCurrency.shortName === 'UZS'">
                            {{
                                item.purchasePrice ? numberWithCommas((item.amount * parseFloat(item.purchasePrice))) : ''
                            }}
                        </span>
                                <span v-else>
                            {{
                                        item.purchasePrice ? numberWithCommas((item.amount * parseFloat(item.purchasePrice)).toFixed(2)) : ''
                                    }}
                        </span>
                            </td>
                        </tr>
                        <tr class="cursor-pointer h-11" @click="selectRow(index)">
                            <td class="font-bold pl-3">{{ $t('sellingPrice') }}</td>
                            <td>
                                {{ item.sellingPrice ? numberWithCommas(parseFloat(item.sellingPrice)) : '' }}
                                {{ showCurrencySymbolById(item.sellingPriceCurrency.id) }}
                            </td>
                        </tr>
                        <tr class="cursor-pointer h-11" @click="selectRow(index)">
                            <td class="font-bold pl-3">{{ $t('sale.sum') }}</td>
                            <td>
                        <span v-if="item.sellingPriceCurrency.shortName === 'UZS'">
                            {{ item.sellingPrice ? numberWithCommas((item.amount * parseInt(item.sellingPrice))) : '' }}
                        </span>
                                <span v-else>
                            {{
                                        item.sellingPrice ? numberWithCommas((item.amount * parseFloat(item.sellingPrice)).toFixed(2)) : ''
                                    }}
                        </span>
                            </td>
                        </tr>
                        <tr class="cursor-pointer h-11" @click="selectRow(index)">
                            <td class="font-bold pl-3">{{ $t('warehouse.title') }}</td>
                            <td>{{ item.warehouse.name }}</td>
                        </tr>
                        <tr class="cursor-pointer h-11" @click="selectRow(index)">
                            <td class="font-bold pl-3">{{ $t('category') }}</td>
                            <td>
                                <div v-for="(category, i) of item.categories" :key="i">
                                    {{ category.name }}
                                </div>
                            </td>
                        </tr>
                        <tr class="h-11" style="border-bottom: 5px solid #707070">
                            <td class="font-bold pl-3">{{ $t('actions') }}</td>
                            <td>
                                <div @click="deleteRowTable(index)">
                                    <img src="/images/Union.png" alt="" class="h-6">
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div v-if="data.productCreatePurchaseMakerDtos.length > 0" class="bg-white rounded shadow mt-3">
                <div class="grid grid-cols-3 py-3">
                    <div class="text-center">
                        <div>
                            {{ $t('printView.totalSum') }}
                        </div>
                        <div class="font-bold">
                            {{ showCurrencyById(currentCurrency.id, totalPrice) }}
                        </div>
                    </div>
                    <div class="text-center">
                        <div>{{ $t('product.count') }}</div>
                        <div class="font-bold">
                            {{ $t('productsInWarehouse.changingProductsAmount', {amount: data.productCreatePurchaseMakerDtos.length}) }}
                        </div>
                    </div>
                    <div class="text-center" v-if="(totalPrice - data.payedAmount) > 0.00">
                        <div>{{ $t('productPurchase.debtAmount') }}</div>
                        <div class="font-bold">
                            {{ showCurrencyById(currentCurrency.id, totalPrice - data.payedAmount) }}
                        </div>
                    </div>
                </div>
            </div>
            
            <div v-if="data.productCreatePurchaseMakerDtos.length > 0" class="bg-white rounded shadow mt-3 py-4">
                <div class="grid grid-cols-10 gap-3 container">
                    <div class="col-span-10 xl:col-span-5 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('supplier.choose') }}
                        </div>
                        <v-select
                            :options="getSuppliers"
                            v-model="data.supplier"
                            :reduce="supplier => supplier"
                            :get-option-label="supplier =>
                            supplier.isCompany ? supplier.supplierCompany.name :
                            supplier.person.givenName + ' ' + supplier.person.familyName"
                        >
                            <template #no-options="{}">
                                {{ $t("selectError") }}
                            </template>
                        </v-select>
                    </div>
                    <div class="col-span-10 sm:col-span-5 xl:col-span-2 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('currencyRate.choose') }}
                        </div>
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            @change="selectCurrency"
                            v-model="currentCurrencyShortName">
                            <b-form-select-option value="UZS">UZS</b-form-select-option>
                            <b-form-select-option value="USD">USD</b-form-select-option>
                            <b-form-select-option value="RUB">RUB</b-form-select-option>
                        </b-form-select>
                    </div>
                    <div class="col-span-10 sm:col-span-5 xl:col-span-3 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                            {{ $t('productPurchase.paymentAmount') }}
                        </div>
                        <b-form-input
                            v-model="data.payedAmount"
                            class="h-11 border-gray-300 focus:ring-0"
                            min="0"
                            type="number"
                        />
                    </div>
                </div>
                
                <div class="grid grid-cols-10 container mt-4">
                    <div class="md:col-start-9 col-span-10 md:col-span-2">
                        <SubmitRow
                            text="save"
                            sm-size="12"
                            md-size="12"
                            :is-disabled="isDisabledSubmit || data.supplier === null"
                            :do-action="createUpdatePurchase"
                            :is-loading="isLoading"
                        />
                    </div>
                </div>
            
            </div>
        </div>

    </Row>
</template>

<script>
import Row from "@/components/html/Row";
import {mapActions, mapGetters} from "vuex";
import vSelect from 'vue-select'
import '../../style/vue-select.css';
import TreeCheckBoxForAddMany from "@/components/TreeCheckBoxForAddMany";
import InputBox from "@/components/InputBox";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import SubmitRow from "@/components/SubmitRow";
import Modal from "@/components/html/Modal.vue";
import ModalWithPicture from "@/components/html/ModalWithPicture.vue";
import CurrencyCollapse from "@/components/CurrencyCollapse.vue";
import barcodeFactoryMixin from "@/mixin/barcodeFactoryMixin";

export default {
    name: "PurchaseProduct",
    components: {
        CurrencyCollapse,
        TreeCheckBoxForAddMany,
        Row,
        vSelect,
        InputBox,
        SubmitRow,
        Modal,
        ModalWithPicture
    },
    mixins: [currencyRateMixin, currencyFormatMixin, barcodeFactoryMixin],
    data() {
        return {
            url: process.env.VUE_APP_API_URL,
            urlUNEC: process.env.VUE_APP_UNEC_API_URL,
            itemName: '',
            itemImageUrl: '',
            activeIndex: null,
            index: 0,
            i: 0,
            currentProduct: null,
            currentCurrency: null,
            isLastElement: false,
            isNewProductBarcode: false,
            isTaggable: true,
            isNeedFilter: true,
            hasDelayed: false,
            isNoDrop: false,
            hasShowProductName: false,
            hasCloseOnSelect: false,
            hasProcessAddingProduct: false,
            selectedProduct: null,
            notEnoughProductId: null,
            isLoadingError: false,
            isLoading: false,
            hasAdditionalUnitOfMeasure: false,
            isExistProduct: false,
            isDisabled: false,
            hasPicture: false,
            next: null,
            totalPrice: 0,
            modalText: '',
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: "purchase"},
            ],
            search: {
                productName: '',
                barCode: null
            },
            image: {
                name: null,
                contentUrl: null
            },
            modelForm: {
                purchasePrice: null,
                priceTotal: null,
                product: null,
                name: null,
                warehouse: null,
                marja: null,
                amount: 1,
                pricePerUnit: null,
                sellingPrice: null,
                sellingCurrency: this.baseCurrencyShortName,
                sellingPriceCurrency: null,
                purchaseCurrency: this.baseCurrencyShortName,
                purchasePriceCurrency: null,
                totalPrice: null,
                shelfLife: null,
                alertAmount: null,
                additionalUnitOfMeasures: [],
                image: null,
                barcode: null,
                purchasePriceUOM: null,
                salePriceUOM: null,
                alertAmountUOM: null,
                categories: [],
                unitOfMeasure: null,
                isNewProduct: false,
                isWeigher: false,
                additionalInformation: null,
                moreUnitOfMeasure: [{
                    product: '',
                    howMany: '',
                    unitOfMeasure: ''
                }],
            },
            initialState: {
                purchasePrice: null,
                priceTotal: null,
                product: null,
                name: null,
                warehouse: null,
                amount: 1,
                pricePerUnit: null,
                sellingPrice: null,
                sellingCurrency: this.baseCurrencyShortName,
                sellingPriceCurrency: null,
                purchaseCurrency: this.baseCurrencyShortName,
                purchasePriceCurrency: null,
                totalPrice: null,
                shelfLife: null,
                alertAmount: null,
                additionalUnitOfMeasures: [],
                image: null,
                barcode: null,
                purchasePriceUOM: null,
                salePriceUOM: null,
                alertAmountUOM: null,
                categories: [],
                unitOfMeasure: null,
                isNewProduct: false,
                additionalInformation: null,
                moreUnitOfMeasure: [{
                    product: '',
                    howMany: '',
                    unitOfMeasure: ''
                }],
            },
            data: {
                currency: null,
                supplier: null,
                totalPrice: null,
                payedAmount: null,
                isPayed: true,
                productCreatePurchaseMakerDtos: []
            },
            errors: {
                productId: null,
                supplierId: null,
                warehouseId: null,
                currencyId: null,
                amount: null,
                pricePerUnit: null,
                shelfLife: null,
            },
        }
    },
    computed: {
        ...mapGetters([
            'getProducts',
            'getWarehouses',
            'getProductCategoriesTree',
            'getSuppliers',
            'getCurrencyByShortName',
            'getIkpu',
            'getProductPurchases',
            'getProductsInWarehouses',
            'getPurchasePageProducts',
            'getUNEC',
            'getUserCompanyId'
        ]),
        unitOfMeasures() {
            return [
                // pic
                {id: "pc", name: this.$t("unitOfMeasure.pc")},

                // weight
                {id: "g", name: this.$t("unitOfMeasure.g")},
                {id: "kg", name: this.$t("unitOfMeasure.kg")},

                // liquid
                {id: "ml", name: this.$t("unitOfMeasure.ml")},
                {id: "l", name: this.$t("unitOfMeasure.l")},

                // length
                {id: "mm", name: this.$t("unitOfMeasure.mm")},
                {id: "cm", name: this.$t("unitOfMeasure.cm")},
                {id: "m", name: this.$t("unitOfMeasure.m")},
                {id: "km", name: this.$t("unitOfMeasure.km")},
                {id: "ft", name: this.$t("unitOfMeasure.ft")},

                // cubic meter
                {id: "m3", name: this.$t("unitOfMeasure.m3")},
            ]
        },
        isDisabledSubmit() {
            return this.data.productCreatePurchaseMakerDtos.some(this.check)
        },
    },
    created() {
        this.$barcodeScanner.init(this.onBarcodeScanned)
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    destroyed() {
        this.$barcodeScanner.destroy()
    },
    methods: {
        ...mapActions([
            'fetchSuppliers',
            'fetchProductsSearch',
            'fetchWarehousesSearch',
            'fetchProductCategoriesTree',
            'pushProduct',
            'pushProductsPurchase',
            'fetchProductsIsNotify',
            'pushAdditionalUnitOfMeasure',
            'pushProductImage',
            'fetchProductInIkpuByBarcode',
            'searchProductPurchase',
            'pushProductCreateAndPurchase',
            'fetchProductPurchase',
            'fetchPurchase',
            'fetchAllProductsInWarehouses',
            'setBreadcrumbItems',
            'searchProductFromUNEC',
            'searchProduct'
        ]),
        onBarcodeScanned(barcode) {
            if (this.isNumber(barcode)) {
                this.search.barCode = barcode
                this.searchProductByBarCode()
            }
        },
        goNext() {
            this.next()
        },
        onPressEnter(event) {
            event.target.blur()
        },
        //push & purchase product
        async createUpdatePurchase() {
            this.$root.showOverlay = true
            this.isLoading = true

            for (let item of this.data.productCreatePurchaseMakerDtos) {
                this.setProduct(item)
            }

            this.setProductPurchase()
            this.setData()

            await this
                .pushProductCreateAndPurchase(this.data)
                .then(() => {
                    this.$store.state.productsInWarehouses.productsInWarehouses.isNeedFetch = true
                    this.$store.state.product.purchasePageProducts.isNeedFetch = true
                    this.isLoading = false
                    this.$root.showOverlay = false

                    this.fetchProductsIsNotify()
                    this.showProductPurchasesCount()
                    this.fetchProductsSearch()

                    this.$i18nHelper.toUrl('products/transactions')
                    this.i = 0
                    this.isLastElement = false
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.isLoading = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                    this.i = 0
                    this.isLastElement = false
                })
        },
        setData() {
            if (this.data.payedAmount === null || this.data.payedAmount === "") {
                this.data.payedAmount = 0
            }

            this.data.totalPrice = this.totalPrice
            this.data.currency = this.currentCurrency

            if (this.data.currency.shortName === 'UZS') {
                this.data.totalPrice = Math.round(this.data.totalPrice)
                this.data.payedAmount = Math.round(this.data.payedAmount)
            } else {
                this.data.totalPrice = parseInt(this.data.totalPrice)
                this.data.payedAmount = parseInt(this.data.payedAmount)
            }

            this.data.currency = this.currentCurrency['@id']

            if (this.data.payedAmount < this.data.totalPrice) {
                this.data.isPayed = false
            }

            if (this.data.supplier.isCompany) {
                this.data.supplier.supplierCompany = this.data.supplier.supplierCompany['@id']
            } else {
                this.data.supplier.person = this.data.supplier.person['@id']
            }
        },
        setProduct(item) {
            item.product.sellingPriceCurrencyId = item.sellingPriceCurrency.id
            item.product.image = item.image

            if (item.additionalInformation !== null) {
                item.product.additionalInformation = item.additionalInformation
            }

            if (item.product.barCode) {
                item.barcode = item.product.barCode
            }

            if (item.categories !== null) {
                item.product.categories = []
                let categories = []
                for (let category of item.categories) {
                    categories.push(category.id)
                    item.product.categories.push(category['@id'])
                }

                item.categories = categories
            }

            delete item.product.additionalUnitOfMeasures

            if (item.image !== null) {
                item.product.image = item.image
            }

            if (item.name !== null) {
                item.product.name = item.name
            }

            item.product.sellingPriceCurrency = item.sellingPriceCurrency['@id']

            if (item.salePriceUOM !== null) {
                item.product.sellingPrice = (item.sellingPrice / item.salePriceUOM.howMany).toString()
            } else {
                item.product.sellingPrice = item.sellingPrice
            }

            item.product.sellingPrice = item.product.sellingPrice.toString()


            if (item.unitOfMeasure === null) {
                item.unitOfMeasure = this.changeUnitOfMeasure(item.product.unitOfMeasure)
            }

            item.unitOfMeasure = this.changeUnitOfMeasure(item.unitOfMeasure)

            if (item.product.name === "" || item.product.name === null) {
                item.product.name = item.name
            }
        },
        setProductPurchase() {
            this.data.productCreatePurchaseMakerDtos.forEach((item) => {
                if (item.purchasePriceUOM) {
                    item.pricePerUnit = (item.purchasePrice / item.purchasePriceUOM.howMany).toString()
                } else if (item.moreUnitOfMeasure.length > 0) {
                    item.pricePerUnit = (item.purchasePrice / item.moreUnitOfMeasure[item.moreUnitOfMeasure.length - 1].howMany).toString()
                    item.amount *= parseFloat(item.moreUnitOfMeasure[item.moreUnitOfMeasure.length - 1].howMany)
                    item.purchasePrice = (item.amount * item.pricePerUnit).toString()
                } else {
                    item.pricePerUnit = item.purchasePrice.toString()
                }

                item.sellingPrice = item.sellingPrice.toString()
                item.alertAmount = parseInt(item.alertAmount)
                item.warehouse = item.warehouse['@id']
                item.sellingPriceCurrency = item.sellingPriceCurrency['@id']
                item.currency = item.purchasePriceCurrency['@id']
                item.purchasePriceCurrency = item.purchasePriceCurrency['@id']
            })
        },
        check(product) {
            return product.name === null ||
                product.purchasePrice === null ||
                product.sellingPrice === null
        },
        // utilities for push & purchase
        setToInitialState() {
            this.hasPicture = false
            this.hasAdditionalUnitOfMeasure = false
            this.modelForm.isWeigher = false
            this.modelForm.shelfLife = null
            this.modelForm.categories = []
            this.modelForm.purchasePrice = null
            this.modelForm.additionalUnitOfMeasures = []
            this.modelForm.sellingPrice = null
            this.modelForm.alertAmount = null
            this.modelForm.barcode = null
            this.modelForm.unitOfMeasure = null
            this.modelForm.purchasePriceUOM = null
            this.modelForm.salePriceUOM = null
            this.modelForm.amount = 1
            this.modelForm.image = null
            this.modelForm.additionalInformation = null
            this.modelForm.moreUnitOfMeasure = []
        },
        addToModelForm(value) {
            if (value.image !== null) {
                this.hasPicture = true
                this.image.name = value.name
                this.image.contentUrl = value.image.contentUrl
            }

            this
                .searchProductPurchase({productId: value.id})
                .then(() => {
                    if (this.getProductPurchases[0] !== undefined) {
                        this.modelForm.purchaseCurrency = this.getProductPurchases[0].currency.shortName
                        this.modelForm.purchasePrice = parseFloat(this.getProductPurchases[0].pricePerUnit)
                        this.data.productCreatePurchaseMakerDtos[this.index].purchasePrice = this.modelForm.purchasePrice
                        this.selectPurchaseCurrency()
                    }
                })

            this.isExistProduct = true
            this.hasAdditionalUnitOfMeasure = false
            this.modelForm.name = value.name
            this.modelForm.additionalUnitOfMeasures = value.additionalUnitOfMeasures
            this.modelForm.additionalInformation = value.additionalInformation
            this.modelForm.sellingPrice = parseFloat(value.sellingPrice)
            this.modelForm.sellingPrice = this.modelForm.sellingPrice.toString()
            this.modelForm.alertAmount = value.alertAmount
            this.modelForm.barcode = value.barCode
            this.modelForm.isNewProduct = false

            if (value.categories.length > 0) {
                for (let category of value.categories) {
                    this.modelForm.categories.push(category)
                }
            }
        },
        sortAdditionalUniOfMeasure(value) {
            for (let unitOfMeasure of this.modelForm.additionalUnitOfMeasures) {
                unitOfMeasure.amount = 0
            }

            if (this.modelForm.additionalUnitOfMeasures[0]['@type'] === 'AdditionalUnitOfMeasure') {
                this.modelForm.additionalUnitOfMeasures.unshift({
                    howMany: 1,
                    amount: 1,
                    unitOfMeasure: this.changeValueUnitOfMeasure(value.unitOfMeasure)
                })
            }

            this.modelForm.purchasePriceUOM = this.modelForm.additionalUnitOfMeasures[0]
            this.modelForm.salePriceUOM = this.modelForm.additionalUnitOfMeasures[0]
        },
        addOrFindFromTable(product) {
            if (this.data.productCreatePurchaseMakerDtos.length > 0) {
                if (this.data.productCreatePurchaseMakerDtos.find((item) => item.product.id === product.product.id)) {
                    let index = this.data.productCreatePurchaseMakerDtos.findIndex(prod => prod.product.id === product.product.id)

                    this.activeIndex = index
                    this.modelForm = {...this.data.productCreatePurchaseMakerDtos[index]}
                    this.index = index
                } else {
                    this.activeIndex = null
                    this.data.productCreatePurchaseMakerDtos.unshift(product)
                    this.index = 0
                }
            } else {
                this.activeIndex = null
                this.data.productCreatePurchaseMakerDtos.unshift(product)
                this.index = this.data.productCreatePurchaseMakerDtos.length - 1
            }
        },
        addOrFindIkpuFromTable(ikpu) {
            if (this.data.productCreatePurchaseMakerDtos.length > 0) {
                if (this.data.productCreatePurchaseMakerDtos.find((item) => item.product.barCode === ikpu.barcode)) {
                    let index = this.data.productCreatePurchaseMakerDtos.findIndex(prod => prod.product.barCode === ikpu.barcode)
                    this.activeIndex = index
                    this.modelForm = {...this.data.productCreatePurchaseMakerDtos[index]}
                    this.index = index

                    setTimeout(() => this.scrollTable(index), 200)
                } else {
                    this.activeIndex = null
                    this.data.productCreatePurchaseMakerDtos.unshift(ikpu)
                    this.index = 0

                    setTimeout(() => this.scrollTable(this.index), 200)
                }
            } else {
                this.activeIndex = null
                this.data.productCreatePurchaseMakerDtos.unshift(ikpu)
                this.index = 0
            }
        },
        calculateTotalPrice() {
            switch (this.currentCurrencyShortName) {
                case 'USD': {
                    this.totalPrice = this.showCurrencyById(null, this.converterValuteToUsd())
                    break
                }

                case 'RUB': {
                    this.totalPrice = this.showCurrencyById(null, this.converterValuteToRub())
                    break
                }

                case 'UZS': {
                    this.totalPrice = this.showCurrencyById(null, this.converterValuteToUzs())
                    break
                }
            }

            if (this.currentCurrency.shortName === undefined) {
                this.getCurrentCurrency()
            }

            if (this.currentCurrency.shortName === 'UZS') {
                this.data.payedAmount = Math.round(this.totalPrice)
            } else {
                this.data.payedAmount = parseFloat(this.totalPrice).toFixed(2)
            }
        },
        converterValuteToUzs() {
            let inUSD = 0.0
            let inRUB = 0.0
            let inUZS = 0.0

            for (let productPurchase of this.data.productCreatePurchaseMakerDtos) {

                if (productPurchase.purchasePriceCurrency.id === this.getCurrencyByShortName('USD').id) {
                    if (productPurchase.purchasePriceUOM !== null) {
                        inUSD += (productPurchase.purchasePrice / productPurchase.purchasePriceUOM.howMany) * productPurchase.amount
                    } else {
                        inUSD += productPurchase.purchasePrice * productPurchase.amount
                    }
                }

                if (productPurchase.purchasePriceCurrency.id === this.getCurrencyByShortName('RUB').id) {
                    if (productPurchase.purchasePriceUOM !== null) {
                        inRUB += (productPurchase.purchasePrice / productPurchase.purchasePriceUOM.howMany) * productPurchase.amount
                    } else {
                        inRUB += productPurchase.purchasePrice * productPurchase.amount
                    }
                }

                if (productPurchase.purchasePriceCurrency.id === this.getCurrencyByShortName('UZS').id) {
                    if (productPurchase.purchasePriceUOM !== null) {
                        inUZS += (productPurchase.purchasePrice / productPurchase.purchasePriceUOM.howMany) * productPurchase.amount
                    } else {
                        inUZS += productPurchase.purchasePrice * productPurchase.amount
                    }
                }
            }

            return inUZS + this.calculateAmountByBaseCurrency(inUSD, "USD", "UZS") + this.calculateAmountByBaseCurrency(inRUB, "RUB", "UZS")
        },
        converterValuteToRub() {
            let inUSD = 0.0
            let inRUB = 0.0
            let inUZS = 0.0

            for (let productPurchase of this.data.productCreatePurchaseMakerDtos) {
                if (productPurchase.purchasePriceCurrency.id === this.getCurrencyByShortName('USD').id) {
                    if (productPurchase.purchasePriceUOM !== null) {
                        inUSD += (productPurchase.purchasePrice / productPurchase.purchasePriceUOM.howMany) * productPurchase.amount
                    } else {
                        inUSD += productPurchase.purchasePrice * productPurchase.amount
                    }
                }

                if (productPurchase.purchasePriceCurrency.id === this.getCurrencyByShortName('RUB').id) {
                    if (productPurchase.purchasePriceUOM !== null) {
                        inRUB += (productPurchase.purchasePrice / productPurchase.purchasePriceUOM.howMany) * productPurchase.amount
                    } else {
                        inRUB += productPurchase.purchasePrice * productPurchase.amount
                    }
                }

                if (productPurchase.purchasePriceCurrency.id === this.getCurrencyByShortName('UZS').id) {
                    if (productPurchase.purchasePriceUOM !== null) {
                        inUZS += (productPurchase.purchasePrice / productPurchase.purchasePriceUOM.howMany) * productPurchase.amount
                    } else {
                        inUZS += productPurchase.purchasePrice * productPurchase.amount
                    }
                }
            }

            return inRUB + this.calculateAmountByBaseCurrency(inUZS, "UZS", "RUB") + this.calculateAmountByBaseCurrency(inUSD, "USD", "RUB")
        },
        converterValuteToUsd() {
            let inUSD = 0.0
            let inUZS = 0.0
            let inRUB = 0.0

            for (let productPurchase of this.data.productCreatePurchaseMakerDtos) {
                if (productPurchase.purchasePriceCurrency.id === this.getCurrencyByShortName('USD').id) {
                    if (productPurchase.purchasePriceUOM !== null) {
                        inUSD += (productPurchase.purchasePrice / productPurchase.purchasePriceUOM.howMany) * productPurchase.amount
                    } else {
                        inUSD += productPurchase.purchasePrice * productPurchase.amount
                    }
                }

                if (productPurchase.purchasePriceCurrency.id === this.getCurrencyByShortName('RUB').id) {
                    if (productPurchase.purchasePriceUOM !== null) {
                        inRUB += (productPurchase.purchasePrice / productPurchase.purchasePriceUOM.howMany) * productPurchase.amount
                    } else {
                        inRUB += productPurchase.purchasePrice * productPurchase.amount
                    }
                }

                if (productPurchase.purchasePriceCurrency.id === this.getCurrencyByShortName('UZS').id) {
                    if (productPurchase.purchasePriceUOM !== null) {
                        inUZS += (productPurchase.purchasePrice / productPurchase.purchasePriceUOM.howMany) * productPurchase.amount
                    } else {
                        inUZS += productPurchase.purchasePrice * productPurchase.amount
                    }
                }
            }

            return inUSD + this.calculateAmountByBaseCurrency(inUZS, "UZS", "USD") + this.calculateAmountByBaseCurrency(inRUB, "RUB", "USD")
        },
        deleteRowTable(index) {
            this.data.productCreatePurchaseMakerDtos.splice(index, 1)
            this.setToInitialState()
            this.index = 0
            this.modelForm.product = null

            if (this.data.productCreatePurchaseMakerDtos.length === 0) {
                this.afterFetchWarehouse()
                this.modelForm.purchaseCurrency = this.baseCurrencyShortName
                this.modelForm.sellingCurrency = this.baseCurrencyShortName
            }
        },
        selectRow(index) {
            this.index = index
            this.activeIndex = index
            this.modelForm = {...this.data.productCreatePurchaseMakerDtos[index]}
            this.modelForm.purchaseCurrency = this.data.productCreatePurchaseMakerDtos[index].purchasePriceCurrency.shortName
            this.hasPicture = true
            this.image.name = this.modelForm.product.name

            if (this.modelForm.product.image !== null && this.modelForm.product.image !== undefined) {
                this.image.contentUrl = this.modelForm.product.image.contentUrl
            }
        },
        selectProduct() {
            if (this.hasProcessAddingProduct) {
                this.modelForm.product.name = this.data.productCreatePurchaseMakerDtos[this.index].product.name
                this.hasProcessAddingProduct = false
                this.isDisabled = false
                this.search.barCode = null
                this.isNoDrop = false
                this.isNewProductBarcode = false
            }
        },
        selectPurchaseCurrency() {
            switch (this.modelForm.purchaseCurrency) {
                case "UZS":
                    this.modelForm.purchasePriceCurrency = this.getCurrencyByShortName("UZS")
                    break

                case "USD":
                    this.modelForm.purchasePriceCurrency = this.getCurrencyByShortName("USD")
                    break

                case "RUB":
                    this.modelForm.purchasePriceCurrency = this.getCurrencyByShortName("RUB")
                    break
            }

            if (this.data.productCreatePurchaseMakerDtos.length > 0) {
                this.data.productCreatePurchaseMakerDtos[this.index].purchasePriceCurrency = this.modelForm.purchasePriceCurrency
            }

            this.calculateTotalPrice()
            this.setMarja()
        },
        selectSellingCurrency(isExistProduct = false) {
            if (isExistProduct) {
                this.modelForm.sellingCurrency = this.modelForm.product.sellingPriceCurrency.shortName
            }

            switch (this.modelForm.sellingCurrency) {
                case "UZS":
                    this.modelForm.sellingPriceCurrency = this.getCurrencyByShortName("UZS")
                    break

                case "USD":
                    this.modelForm.sellingPriceCurrency = this.getCurrencyByShortName("USD")
                    break

                case "RUB":
                    this.modelForm.sellingPriceCurrency = this.getCurrencyByShortName("RUB")
                    break
            }

            if (this.data.productCreatePurchaseMakerDtos.length > 0) {
                this.data.productCreatePurchaseMakerDtos[this.index].sellingPriceCurrency = this.modelForm.sellingPriceCurrency
            }

            this.setMarja()
        },
        whenSelectProduct(value) {
            if (this.modelForm.purchaseCurrency === null) {
                this.modelForm.purchaseCurrency = this.baseCurrencyShortName
            }

            if (value === null) {
                return
            }

            if (this.hasProcessAddingProduct) {
                this.modelForm.unitOfMeasure = this.changeValueUnitOfMeasure('pc')
                this.search.barCode = null
                return;
            }

            this.search.barCode = null

            if (typeof value === 'string') {
                let data = {}
                data.name = value
                value = data
                this.modelForm.product = data
            }

            this.setToInitialState()

            if (value['@type'] === 'Product') {
                if (!this.hasDelayed) {
                    this.addToModelForm(value)

                    if (this.modelForm.additionalUnitOfMeasures.length > 0) {
                        this.sortAdditionalUniOfMeasure(value)
                    } else {
                        this.modelForm.unitOfMeasure = this.changeValueUnitOfMeasure(value.unitOfMeasure)
                        this.isDisabled = true
                    }

                    if (this.modelForm.warehouse === null) {
                        this.afterFetchWarehouse()
                    }

                    if (value.barCode === null || value.barCode === '') {
                        if (!this.modelForm.isWeigher) {
                            this.modelForm.barcode = this.generateBarcode(value.unitOfMeasure, value.id)
                            this.modelForm.product.barCode = this.modelForm.barcode
                        }
                    }

                    this.selectPurchaseCurrency()
                    this.selectSellingCurrency(true)
                    let product = {...this.modelForm}
                    this.addOrFindFromTable(product)

                    this.modelForm.sellingPriceCurrency = null
                    this.modelForm.purchasePriceCurrency = null
                }
            } else {
                this.pushProduct({
                    name: value.name,
                    sellingPrice: '0',
                    barCode: null,
                    unitOfMeasure: 'pc',
                    sellingPriceCurrencyId: this.baseCurrencyId,
                    image: null,
                    categories: [],
                    additionalInformation: ''
                }).then((response) => {
                        this.modelForm.product.id = response.id
                        this.modelForm.product['@id'] = response['@id']
                        this.modelForm.product['@type'] = 'Product'

                        if (!this.modelForm.isWeigher) {
                            this.modelForm.barcode = this.generateBarcode(response.unitOfMeasure, response.id)
                        }

                        this.selectPurchaseCurrency()
                        this.selectSellingCurrency()

                        this.isDisabled = false
                        this.isExistProduct = false
                        this.modelForm.name = value.name
                        this.modelForm.product = value
                        this.modelForm.isNewProduct = true
                        this.modelForm.product.sellingPriceCurrency = this.modelForm.sellingPriceCurrency
                        this.modelForm.unitOfMeasure = this.changeValueUnitOfMeasure('pc')
                        let product = {...this.modelForm}
                        this.activeIndex = null

                        this.data.productCreatePurchaseMakerDtos.unshift(product)
                        this.index = 0
                    }
                )
            }
        },
        searchProductByBarCode() {
            if (this.modelForm.purchaseCurrency === null) {
                this.modelForm.purchaseCurrency = this.baseCurrencyShortName
            }

            if (this.isNumber(this.search.barCode)) {
                if ((this.search.barCode.length === 8 || this.search.barCode.length === 13) && /^\d+$/.test(this.search.barCode)) {
                    this.isNeedFilter = false
                    this.isTaggable = false
                    this.hasDelayed = true

                    let value = this.getPurchasePageProducts.find(product => this.search.barCode === product.barCode)

                    if (value === undefined) {
                        if (this.data.productCreatePurchaseMakerDtos.find(product => this.search.barCode === product.barCode)) {
                            this.hasProcessAddingProduct = true
                            let index = this.data.productCreatePurchaseMakerDtos.findIndex(item => this.search.barCode === item.barcode)
                            this.activeIndex = index
                            this.modelForm = {...this.data.productCreatePurchaseMakerDtos[index]}
                            this.index = index
                            this.isDisabled = false
                            setTimeout(() => this.scrollTable(index), 200)

                            return
                        }
                    }

                    if (value === undefined) {
                        this.pushProduct({
                            name: '-',
                            sellingPrice: '0',
                            barCode: null,
                            unitOfMeasure: 'pc',
                            sellingPriceCurrencyId: this.baseCurrencyId,
                            image: null,
                            categories: [],
                            additionalInformation: ''
                        }).then((response) => {
                            this.isExistProduct = false

                            let barcode = (' ' + this.search.barCode).slice(1)
                            this.hasProcessAddingProduct = true

                            this
                                .searchProductFromUNEC({barcode: this.search.barCode, url: this.urlUNEC})
                                .then(() => {
                                    this.setToInitialState()

                                    if (this.getUNEC === null) {
                                        this.selectSellingCurrency(false)
                                        this.selectPurchaseCurrency(false)

                                        this.modelForm.product = {
                                            id: response.id,
                                            '@id': response['@id'],
                                            '@type': response['@type']
                                        }

                                        this.modelForm.product.name = ''
                                        this.modelForm.product.barCode = barcode
                                        this.modelForm.barcode = barcode
                                        this.modelForm.name = ''
                                        this.isNewProductBarcode = true
                                        this.modelForm.isNewProduct = true

                                        this.modelForm.product.sellingPriceCurrency = this.modelForm.sellingPriceCurrency
                                        let product = {...this.modelForm}
                                        this.data.productCreatePurchaseMakerDtos.unshift(product)
                                        this.index = 0

                                        setTimeout(() => {
                                            this.search.barCode = null
                                            this.hasDelayed = false
                                            this.modelForm.product = {}
                                            this.modelForm.product.name = ''
                                            this.isTaggable = true
                                        }, 1000)
                                    } else {
                                        this.isNeedFilter = true
                                        this.isTaggable = false
                                        this.modelForm.barcode = this.getUNEC.internationalCode
                                        this.modelForm.product = {}
                                        this.modelForm.name = this.getUNEC.name
                                        this.modelForm.unitOfMeasure = this.changeValueUnitOfMeasure('pc')
                                        this.isNewProductBarcode = true
                                        this.modelForm.isNewProduct = true
                                        this.selectSellingCurrency(false)
                                        this.selectPurchaseCurrency(false)
                                        this.hasProcessAddingProduct = true
                                        this.hasShowProductName = true
                                        this.hasPicture = false
                                        this.isDisabled = false
                                        this.isExistProduct = false

                                        if (this.modelForm.warehouse === null) {
                                            this.afterFetchWarehouse()
                                        }

                                        this.modelForm.product = {
                                            name: this.getUNEC.name,
                                            barcode: this.getUNEC.internationalCode,
                                            sellingPriceCurrency: this.modelForm.sellingPriceCurrency,
                                            id: response.id,
                                            '@id': response['@id'],
                                            '@type': response['@type']
                                        }

                                        let product = {...this.modelForm}

                                        this.addOrFindIkpuFromTable(product)

                                        setTimeout(() => {
                                            this.search.barCode = ""
                                            this.isNeedFilter = true
                                            this.hasDelayed = false
                                            this.isTaggable = true
                                        }, 200)
                                    }
                                })
                        })
                            .catch((reason) => {
                                this.isLoading = false
                                this.$root.showOverlay = false
                                this.modalText = reason
                                this.$bvModal.show('modal_show')
                            })
                    } else {
                        this.selectPurchaseCurrency()
                        this.selectSellingCurrency()
                        this.currentProduct = value
                        this.addToModelForm(value)
                        this.hasProcessAddingProduct = true
                        this.modelForm.isNewProduct = false

                        if (this.modelForm.additionalUnitOfMeasures.length > 0) {
                            this.sortAdditionalUniOfMeasure(value)
                        } else {
                            this.modelForm.unitOfMeasure = this.changeValueUnitOfMeasure(value.unitOfMeasure)
                            this.isDisabled = true
                        }

                        if (this.modelForm.warehouse === null) {
                            this.afterFetchWarehouse()
                        }

                        this.modelForm.product = value
                        let product = {...this.modelForm}

                        this.addOrFindFromTable(product)

                        setTimeout(() => {
                            this.search.barCode = ""
                            this.isNeedFilter = true
                            this.hasDelayed = false
                            this.isTaggable = true
                        }, 200)
                    }
                }
            } else {
                // this.search.product = this.search.barCode
                // this.search.isPurchaseProductPage = true
                // this.searchProduct(this.search)

                if (this.modelForm.barcode) {
                    if (this.modelForm.barcode.length === 13 && this.isNumber(this.modelForm.barcode)) {
                        this.hasProcessAddingProduct = false
                    }
                }
            }
        },
        isNumber(n) {
            return /^-?[\d.]+(?:e-?\d+)?$/.test(n)
        },
        clearInput() {
            this.search.barCode = null
            this.isNoDrop = false
        },
        getCurrentCurrency() {
            switch (this.currentCurrencyShortName) {
                case "UZS":
                    this.currentCurrency = this.getCurrencyByShortName("UZS")
                    break

                case "USD":
                    this.currentCurrency = this.getCurrencyByShortName("USD")
                    break

                case "RUB":
                    this.currentCurrency = this.getCurrencyByShortName("RUB")
                    break
            }
        },
        selectCurrency() {
            switch (this.currentCurrencyShortName) {
                case "UZS":
                    this.currentCurrency = this.getCurrencyByShortName("UZS")
                    break

                case "USD":
                    this.currentCurrency = this.getCurrencyByShortName("USD")
                    break

                case "RUB":
                    this.currentCurrency = this.getCurrencyByShortName("RUB")
                    break
            }

            if (this.data.productCreatePurchaseMakerDtos.length > 0) {
                this.calculateTotalPrice()
            }
        },
        setPurchasePrice() {
            this.data.productCreatePurchaseMakerDtos[this.index].purchasePrice = this.modelForm.purchasePrice

            if (this.modelForm.marja !== null) {
                this.modelForm.sellingPrice = parseFloat(this.modelForm.purchasePrice) + ((this.modelForm.purchasePrice * this.modelForm.marja) / 100)
                this.data.productCreatePurchaseMakerDtos[this.index].sellingPrice = this.modelForm.sellingPrice
            }

            this.calculateTotalPrice()
            this.setMarja()
        },
        setAdditionalInfo() {
            this.data.productCreatePurchaseMakerDtos[this.index].additionalInformation = this.modelForm.additionalInformation
        },
        setSellingPrice() {
            this.data.productCreatePurchaseMakerDtos[this.index].sellingPrice = this.modelForm.sellingPrice
            let diff = this.modelForm.sellingPrice - this.modelForm.purchasePrice

            if (!this.hasAdditionalUnitOfMeasure) {
                this.modelForm.marja = Math.round(diff * 100 / this.modelForm.purchasePrice)
            }
        },
        setMarja() {
            if (this.modelForm.purchasePrice !== null) {
                if (this.modelForm.sellingPriceCurrency === null) {
                    this.modelForm.sellingPriceCurrency = this.modelForm.purchasePriceCurrency
                }

                if (this.modelForm.purchasePriceCurrency.shortName === this.modelForm.sellingPriceCurrency.shortName) {
                    if (this.modelForm.marja !== null) {
                        this.modelForm.sellingPrice = parseFloat(this.modelForm.purchasePrice) + ((this.modelForm.purchasePrice * this.modelForm.marja) / 100)
                        this.data.productCreatePurchaseMakerDtos[this.index].sellingPrice = this.modelForm.sellingPrice
                    }
                } else {
                    if (this.modelForm.marja !== null) {
                        this.modelForm.sellingPrice = this.calculateAmountByBaseCurrency(
                            this.modelForm.purchasePrice,
                            this.modelForm.purchasePriceCurrency.shortName,
                            this.modelForm.sellingPriceCurrency.shortName
                        ) + ((this.calculateAmountByBaseCurrency(
                            this.modelForm.purchasePrice,
                            this.modelForm.purchasePriceCurrency.shortName,
                            this.modelForm.sellingPriceCurrency.shortName
                        ) * this.modelForm.marja) / 100)

                        if (this.modelForm.sellingPriceCurrency.shortName === "UZS") {
                            this.modelForm.sellingPrice = Math.round(this.modelForm.sellingPrice)
                        } else {
                            this.modelForm.sellingPrice = this.modelForm.sellingPrice.toFixed(2)
                        }

                        this.data.productCreatePurchaseMakerDtos[this.index].sellingPrice = this.modelForm.sellingPrice
                    }
                }
            }
        },
        setUOM(value) {
            let modelForm = this.data.productCreatePurchaseMakerDtos[this.index]
            modelForm.unitOfMeasure = this.changeUnitOfMeasure(value)

            if (modelForm.barcode.length === 13 && modelForm.barcode[0] === '2') {
                if (!this.modelForm.isWeigher) {
                    modelForm.barcode = this.generateBarcode(modelForm.unitOfMeasure, modelForm.product.id)
                    this.modelForm.barcode = modelForm.barcode
                    this.modelForm.product.barCode = this.modelForm.barcode
                }
            }
        },
        setPurchaseAddUOM() {
            this.data.productCreatePurchaseMakerDtos[this.index].purchasePriceUOM = this.changeUnitOfMeasure(this.modelForm.purchasePriceUOM)

            this.calculateTotalPrice()
        },
        setSellingAddUOM() {
            this.data.productCreatePurchaseMakerDtos[this.index].salePriceUOM = this.changeUnitOfMeasure(this.modelForm.salePriceUOM)
        },
        setCategory() {
            if (this.data.productCreatePurchaseMakerDtos.length > 0) {
                this.data.productCreatePurchaseMakerDtos[this.index].categories = this.modelForm.categories
            }
        },
        setWarehouse() {
            this.data.productCreatePurchaseMakerDtos[this.index].warehouse = this.modelForm.warehouse
        },
        setBarcode() {
            this.data.productCreatePurchaseMakerDtos[this.index].product.barCode = this.modelForm.barcode
            this.data.productCreatePurchaseMakerDtos[this.index].barcode = this.modelForm.barcode
        },
        setAlertAmount() {
            this.data.productCreatePurchaseMakerDtos[this.index].alertAmount = this.modelForm.alertAmount
        },
        setIsWeigher() {
            if (this.data.productCreatePurchaseMakerDtos.length) {
                this.data.productCreatePurchaseMakerDtos[this.index].isWeigher = this.modelForm.isWeigher
            }

            if (this.modelForm.isWeigher && this.data.productCreatePurchaseMakerDtos.length) {
                this.data.productCreatePurchaseMakerDtos[this.index].product.barCode = null
                this.data.productCreatePurchaseMakerDtos[this.index].barcode = null
                this.modelForm.barcode = null
            }
        },
        setExpirationDate() {
            this.data.productCreatePurchaseMakerDtos[this.index].shelfLife = this.modelForm.shelfLife
        },
        changeValueUnitOfMeasure(unitOfMeasure) {
            switch (unitOfMeasure) {
                case 'pc' :
                    return this.$t("unitOfMeasure.pc")
                case 'g' :
                    return this.$t("unitOfMeasure.g")
                case 'kg' :
                    return this.$t("unitOfMeasure.kg")
                case 'ml' :
                    return this.$t("unitOfMeasure.ml")
                case 'l' :
                    return this.$t("unitOfMeasure.l")
                case 'mm' :
                    return this.$t("unitOfMeasure.mm")
                case 'cm' :
                    return this.$t("unitOfMeasure.cm")
                case 'm' :
                    return this.$t("unitOfMeasure.m")
                case 'km' :
                    return this.$t("unitOfMeasure.km")
                case 'ft' :
                    return this.$t("unitOfMeasure.ft")
                case 'm3' :
                    return this.$t("unitOfMeasure.m3")
                default:
                    return unitOfMeasure
            }
        },
        changeUnitOfMeasure(unitOfMeasure) {
            switch (unitOfMeasure) {
                case this.$t("unitOfMeasure.pc") :
                    return 'pc'
                case this.$t("unitOfMeasure.g") :
                    return 'g'
                case this.$t("unitOfMeasure.kg") :
                    return 'kg'
                case this.$t("unitOfMeasure.ml") :
                    return 'ml'
                case this.$t("unitOfMeasure.l") :
                    return 'l'
                case this.$t("unitOfMeasure.mm") :
                    return 'mm'
                case this.$t("unitOfMeasure.cm") :
                    return 'cm'
                case this.$t("unitOfMeasure.m") :
                    return 'm'
                case this.$t("unitOfMeasure.km") :
                    return 'km'
                case this.$t("unitOfMeasure.ft") :
                    return 'ft'
                case this.$t("unitOfMeasure.m3") :
                    return 'm3'
                default:
                    return unitOfMeasure
            }
        },
        calculateAmount() {
            this.modelForm.amount = 0

            for (let amount of this.quantityCalculation) {
                if (amount.amountUnitOfMeasures !== '' && amount.unitOfMeasures !== null) {
                    this.modelForm.amount += amount.unitOfMeasures.howMany * amount.amountUnitOfMeasures
                }
            }
        },
        importImage(event) {
            this.alertInvalidImage = false
            this.isLoadingError = true
            this.file = event.target.files[0]
            const data = new FormData();
            data.append('file', this.file)

            this.pushProductImage(data)
                .then((res) => {
                    this.modelForm.image = res['@id']
                    this.data.productCreatePurchaseMakerDtos[this.index].image = this.modelForm.image

                    setTimeout(() => this.isLoadingError = false, 1000)
                })
                .catch((err) => {
                    this.isLoadingError = false;

                    if (err === 'file: Please upload a valid image') {
                        this.alertText = this.$t('image.validImage')
                    } else {
                        this.alertText = err
                    }

                    this.alertInvalidImage = true
                    this.file = null
                })
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        },
        expirationDate() {
            this.hasExpirationDate = false
        },
        scrollTable(index) {
            let rows = [];

            if (this.data.productCreatePurchaseMakerDtos.length > 3) {
                let table = document.querySelector('table');
                // get array of rows of table products
                rows = table.querySelectorAll('tr');
            }

            if (rows.length > 3) {
                // scroll index of table row
                rows[index].scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                })
            }
        },
        showProductPurchasesCount() {
            if (this.$i18n.locale === 'uz') {
                this.$i18nHelper.flash(this.data.productCreatePurchaseMakerDtos.length + ' ta mahsulot xarid qilindi', 'success')
            } else if (this.$i18n.locale === 'ru') {
                this.$i18nHelper.flash(this.data.productCreatePurchaseMakerDtos.length + ' товари были куплены', 'success')
            } else {
                this.$i18nHelper.flash(this.data.productCreatePurchaseMakerDtos.length + ' products have been purchased', 'success')
            }
        },
        afterFetchSupplier() {
            if (this.getSuppliers[0].text === undefined) {
                this.data.supplier = this.getSuppliers[0]

                for (let index in this.getSuppliers) {
                    this.getSuppliers[index].text = this.getSuppliers[index].isCompany ?
                        this.getSuppliers[index].supplierCompany.name :
                        this.getSuppliers[index].person.givenName + ' ' + this.getSuppliers[index].person.familyName
                }
            } else {
                this.$store.state.supplier.suppliers.isNeedFetch = true
                this
                    .fetchSuppliers(null)
                    .then(() => {
                        this.data.supplier = this.getSuppliers[0]

                        for (let index in this.getSuppliers) {
                            this.getSuppliers[index].text = this.getSuppliers[index].isCompany ?
                                this.getSuppliers[index].supplierCompany.name :
                                this.getSuppliers[index].person.givenName + ' ' + this.getSuppliers[index].person.familyName
                        }
                    })
            }
        },
        afterFetchWarehouse() {
            if (this.getWarehouses.length > 0) {
                this.modelForm.warehouse = this.getWarehouses[0]
            }
        },
        increaseAmount(product, unit) {
            if (unit === undefined) {
                product.amount++
            } else {
                product.amount += unit.howMany
                unit.amount++
            }

            this.calculateTotalPrice()
        },
        decreaseAmount(product, unit) {
            if (unit === undefined) {
                product.amount--
            } else {
                product.amount -= unit.howMany
                unit.amount--
            }

            this.calculateTotalPrice()
        },
        calcProductAmount(product, unit) {
            if (unit !== undefined) {
                product.amount = 0

                for (let u of product.additionalUnitOfMeasures) {
                    if (u.amount > 0) {
                        product.amount += u.howMany * u.amount
                    }
                }
            }

            this.calculateTotalPrice()
        },
        clearAddUOM() {
            this.closeAdditionalUOM()
        },
        deleteOneUnit(index) {
            this.modelForm.moreUnitOfMeasure.splice(index, 1)
        },
        addMoreUnit() {
            this.modelForm.moreUnitOfMeasure.push({
                product: '',
                howMany: '',
                unitOfMeasure: ''
            })
        },
        showAdditionalUOM() {
            this.hasAdditionalUnitOfMeasure = true

            if (this.modelForm.moreUnitOfMeasure.length === 0) {
                this.addMoreUnit()
            }
        },
        closeAdditionalUOM() {
            this.hasAdditionalUnitOfMeasure = false

            if (this.modelForm.moreUnitOfMeasure.some((item) => {
                return item.howMany === "" || item.unitOfMeasure === ""
            })) {
                this.modelForm.moreUnitOfMeasure = []
                if (this.data.productCreatePurchaseMakerDtos.length > 0) {
                    this.data.productCreatePurchaseMakerDtos[this.index].moreUnitOfMeasure = this.modelForm.moreUnitOfMeasure
                }
            }
        },
        setModal(name, url) {
            this.itemName = name
            this.itemImageUrl = url
            this.$bvModal.show('show_picture')
        },
        afterFetchPurchase(response) {
            this.data.currency = response.currency['@id']
            this.data.payedAmount = parseFloat(response.payedAmount)
            this.data.totalPrice = parseFloat(response.totalPrice)
            this.data.supplier = response.supplier
            this.setToInitialState()

            response.productPurchases.map(pp => {
                let piw = this.getProductsInWarehouses.find(piw => piw['@id'] === pp.productInWarehouses[0])

                if (piw) {
                    this.modelForm.alertAmount = piw.alertAmount
                }

                this.modelForm.amount = parseFloat(pp.amount)
                this.modelForm.sellingPrice = pp.product.sellingPrice
                this.modelForm.sellingPriceCurrency = pp.product.sellingPriceCurrency
                this.modelForm.product = pp.product
                this.modelForm.warehouse = pp.warehouse
                this.modelForm.name = pp.product.name
                this.modelForm.additionalUnitOfMeasures = pp.product.additionalUnitOfMeasures
                this.modelForm.additionalInformation = pp.product.additionalInformation
                this.modelForm.barcode = pp.product.barCode
                this.modelForm.shelfLife = pp.shelfLife
                this.modelForm.unitOfMeasure = pp.product.unitOfMeasure
                this.modelForm.purchasePriceCurrency = pp.currency
                this.modelForm.totalPrice = pp.totalPrice
                this.modelForm.purchasePrice = parseFloat(pp.pricePerUnit)
                this.modelForm.purchaseCurrency = pp.currency.shortName
                let product = {...this.modelForm}
                this.data.productCreatePurchaseMakerDtos.push(product)
                this.setToInitialState()
            })

            this.calculateTotalPrice()

            this.$root.showOverlay = false
        },
        afterFetchProductPurchase(response) {
            let piw = this.getProductsInWarehouses.find(piw => piw['@id'] === response.productInWarehouses[0])

            if (piw) {
                this.modelForm.alertAmount = piw.alertAmount
            }

            this.data.currency = response.currency['@id']
            this.data.payedAmount = parseFloat(response.payedAmount)
            this.data.totalPrice = parseFloat(response.totalPrice)
            this.data.supplier = response.supplier
            this.modelForm.amount = parseFloat(response.amount)
            this.modelForm.sellingPrice = response.product.sellingPrice
            this.modelForm.sellingPriceCurrency = response.product.sellingPriceCurrency
            this.modelForm.product = response.product
            this.modelForm.warehouse = response.warehouse
            this.modelForm.name = response.product.name
            this.modelForm.additionalUnitOfMeasures = response.product.additionalUnitOfMeasures
            this.modelForm.additionalInformation = response.product.additionalInformation
            this.modelForm.barcode = response.product.barCode
            this.modelForm.shelfLife = response.shelfLife
            this.modelForm.unitOfMeasure = response.product.unitOfMeasure
            this.modelForm.purchasePriceCurrency = response.currency
            this.modelForm.totalPrice = response.totalPrice
            this.modelForm.purchasePrice = parseFloat(response.pricePerUnit)
            this.modelForm.purchaseCurrency = response.currency.shortName
            let product = {...this.modelForm}
            this.data.productCreatePurchaseMakerDtos.push(product)
            this.setToInitialState()
            this.calculateTotalPrice()

            this.$root.showOverlay = false
        }
    },
    watch: {
        'data.productCreatePurchaseMakerDtos'() {
            setTimeout(() => this.calculateTotalPrice(), 200)
        },
        'modelForm.amount'() {
            this.data.productCreatePurchaseMakerDtos[this.index].amount = this.modelForm.amount
        }
    },
    beforeRouteLeave (to, from , next) {
        if (this.data.productCreatePurchaseMakerDtos.length > 0 && to.name !== 'products/transactions') {
            this.modalText = this.$t('beforeLeaveAdvice')
            this.$bvModal.show('modal_router')
            this.next = next
        } else {
            next()
        }
    },
    mounted() {
        this.$root.showOverlay = true

        this.fetchSuppliers(null)
            .then(() => {
                this.fetchProductCategoriesTree(null)
                    .then(() => {
                        this.fetchWarehousesSearch(null)
                            .then(() => {
                                this.selectCurrency()
                                this.modelForm.sellingCurrency = this.baseCurrencyShortName
                                this.modelForm.purchaseCurrency = this.baseCurrencyShortName
                                this.afterFetchWarehouse()
                                this.afterFetchSupplier()
                                this.selectCurrency()
                                this.$root.showOverlay = false

                            })
                    })
            })

        if (this.$route.params.id !== '0') {
            this.fetchAllProductsInWarehouses()
                .then(() => {
                    this.fetchPurchase(this.$route.params.id)
                        .then((response) => {
                            this.afterFetchPurchase(response)
                        })
                        .catch((error) => {
                            if (error === 'Not Found') {
                                this.fetchProductPurchase(this.$route.params.id)
                                    .then((response) => {
                                        this.afterFetchProductPurchase(response)
                                    })
                            }
                        })
                })
        }
    },
}
</script>

<style scoped>

::-webkit-scrollbar {
    width: 2px;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #6539B2;
}

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

.disabled-input:disabled {
    background-color: #fbfbfb !important;
}

v-select:disabled {
    background-color: #fbfbfb !important;
}

.text-light span {
    font-size: 12px;
}

.list-product .right {
    text-align: right;
}

.list-product .center {
    text-align: center;
}

.product-card > span {
    display: flex;
    justify-content: center;
    justify-self: center;
    margin-top: 6px;
}
</style>
